
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from 'react-hook-form';

interface ChronicConditionsFieldProps {
  form: UseFormReturn<any>;
}

const ChronicConditionsField: React.FC<ChronicConditionsFieldProps> = ({ form }) => {
  const watchHasChronicConditions = form.watch("hasChronicConditions");

  return (
    <div className="space-y-4 border-b pb-4">
      <FormField
        control={form.control}
        name="hasChronicConditions"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3">
            <div className="space-y-0.5">
              <FormLabel>Do you have any chronic health conditions?</FormLabel>
              <FormDescription>
                E.g., diabetes, thyroid disorders, hypertension, etc.
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {watchHasChronicConditions && (
        <FormField
          control={form.control}
          name="chronicConditionsDetails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Please describe your chronic conditions</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Please provide details about your chronic conditions"
                  className="resize-none"
                  {...field}
                  value={field.value || ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
};

export default ChronicConditionsField;
